'use client'

import { useAuth } from '@/lib/auth/auth-context'

/**
 * A small badge overlay showing the count of pending invitations.
 * Designed to be positioned absolutely over an avatar.
 */
export function InvitationBadge() {
  const { pendingInvitationsCount, isAuthenticated } = useAuth()

  if (!isAuthenticated || pendingInvitationsCount === 0) {
    return null
  }

  return (
    <span className="absolute -top-1 -right-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-zinc-700 dark:bg-zinc-300 text-[10px] font-medium text-white dark:text-zinc-900 px-1 shadow-sm">
      {pendingInvitationsCount > 9 ? '9+' : pendingInvitationsCount}
    </span>
  )
}
